import {forwardRef, Inject, Injectable} from "@angular/core";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {TranslateService} from "@ngx-translate/core";
import {PopupServices} from "./popup.services";
import {Enterprise} from "../model/Enterprise";
import {DlgCgiConnect} from "../common/components/cgi-connect/DlgCgiConnect";
import {SessionService} from "./session.service";

@Injectable()
export class TokenServices {
  constructor(
    @Inject(forwardRef(() => NgbModal)) private modalService: NgbModal,
    @Inject(forwardRef(() => PopupServices)) private popupServices: PopupServices,
    @Inject(forwardRef(() => TranslateService)) private translate: TranslateService,
    @Inject(forwardRef(() => SessionService)) private sessionService: SessionService
  ) {

  }


  private _createModalRef(placementHolder?: string){
    let modalRef = null;
    if (placementHolder && placementHolder.trim().length>0){
      modalRef = this.modalService.open(DlgCgiConnect,{container:placementHolder});
    }else{
      modalRef = this.modalService.open(DlgCgiConnect);
    }
    return modalRef;
  }

  public openCgiConnect(enterprise: Enterprise, placementHolder?: string):Promise<any>{
    const modalRef = this._createModalRef(placementHolder);
    modalRef.componentInstance.populate(enterprise);
    return modalRef.result;
    // modalRef.result.then((result) => {
    // });
  }

}
